import React from "react";
import { WHATSAPP_NUMBER } from "./Footer";

const WhatsAppButton = () => {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}`}
      target="_blank"
      rel="noopener noreferrer"
      className="sticky-whatsapp-btn hover-scale-sm" style={{ padding: "15px 15px" }}
      aria-label="Chat with us on WhatsApp"
    >
      <svg viewBox="0 0 32 32" fill="#fff" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.004 3C9.107 3 3.5 8.607 3.5 15.504c0 2.316.63 4.485 1.727 6.35L3 29l7.32-2.183a12.45 12.45 0 005.684 1.383h.004c6.897 0 12.504-5.607 12.504-12.504C28.512 8.607 22.905 3 16.004 3zm0 22.7h-.003a10.2 10.2 0 01-5.198-1.424l-.373-.221-4.344 1.295 1.317-4.235-.243-.387a10.18 10.18 0 01-1.56-5.44c0-5.634 4.588-10.222 10.226-10.222 2.732 0 5.3 1.065 7.23 2.997a10.15 10.15 0 013 7.229c0 5.635-4.589 10.223-10.055 10.223zm5.61-7.658c-.307-.154-1.816-.897-2.098-1a.42.42 0 00-.598-.06c-.176.153-.681.746-.834.9-.152.153-.306.176-.567.06-.306-.153-1.294-.477-2.464-1.522-.911-.812-1.526-1.815-1.705-2.121-.176-.307-.02-.472.135-.625.14-.14.307-.36.46-.541.153-.181.204-.31.306-.516.102-.207.05-.386-.026-.541-.076-.153-.686-1.65-.94-2.264-.247-.594-.499-.514-.686-.524-.176-.008-.378-.01-.58-.01a1.11 1.11 0 00-.803.374c-.276.307-1.056 1.032-1.056 2.517s1.08 2.918 1.23 3.121c.153.204 2.126 3.248 5.152 4.554.72.31 1.281.496 1.719.635.723.23 1.38.198 1.9.12.579-.086 1.816-.742 2.072-1.459.256-.716.256-1.33.179-1.459-.076-.128-.28-.204-.588-.358z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
